import { memo } from 'react';

const MTag = ({ title, extraClassName }) => {
    return (
      <div
        className={`rounded px-3 py-1 bg-slate-300 overflow-hidden whitespace-nowrap text-ellipsis max-w-fit truncate ${extraClassName}`}>
          {title}
      </div>
    );
};

export default memo(MTag);
